var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFb = function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 4a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17m1.544 5.178h-.918c-1.101 0-1.489.556-1.489 1.49v.687h-.687V12.5h.687v3.322h1.374V12.5h.917l.122-1.145h-1.039l.002-.573c0-.298.028-.458.457-.458h.574z"
  })));
};
export default SvgFb;